import api from '../api';

// Fetches the venue assigned to the user
export const fetchVenueForUser = async (userId) => {
  try {
    const { data } = await api.get('/get_user_state_assignment/', {
      params: { user_id: userId }
    });
    if (data.status === 'success') {
      return data.venue_name;
    }
  } catch (error) {
    console.error('Error fetching venue name for user', userId, ':', error);
  }
  return null;
};

// Saves a venue selection for the user
export const saveVenueToUser = async (user_id, venueName) => {
  try {
    const { data } = await api.post(
      '/select_venue/',
      null,
      { params: { user_id, venue_name: venueName } }
    );
    if (data.status !== 'success') {
      console.error('Saving venue to user profile got non-success response:', data);
    }
  } catch (error) {
    console.error('Saving venue to user profile got error:', error);
  }
};

// Retrieves unit settings for the user
export async function fetchUnitSettingsForUser(userId) {
  try {
    const { data } = await api.get('/get_unit_settings/', {
      params: { user_id: userId }
    });
    if (data.status === 'success') {
      const { status, ...settings } = data;
      return settings;
    }
  } catch (err) {
    console.error('Error fetching unit settings:', err);
  }
  return null;
}

// Retrieves the full list of venues
export const getVenuesList = async (userId) => {
  try {
    const { data } = await api.get('/get_all_venues/', {
      params: { user_id: userId }
    });
    if (data.status === 'success') {
      return data.venues;
    } else {
      console.error('Error from server:', data.message);
    }
  } catch (error) {
    console.error('Error fetching venues list:', error);
  }
  return [];
};

// Retrieves the user's account type
export const getUserAccountType = async (userId) => {
  try {
    const { data } = await api.get('/get_user_account_type/', {
      params: { user_id: userId }
    });
    if (data.status === 'success') {
      return data.account_type;
    }
  } catch (error) {
    console.error('Error fetching account type:', error);
  }
  return 'business';
};

// Retrieves venues the user has selected
export const getUserSelectedVenues = async (userId) => {
  try {
    const { data } = await api.get('/get_user_selected_venues/', {
      params: { user_id: userId }
    });
    if (data.status === 'success') {
      return data.selected_venues;
    } else {
      console.error('Error from server:', data.message);
    }
  } catch (error) {
    console.error('Error fetching user selected venues:', error);
  }
  return [];
};

// Saves the user's unit preferences to the backend
export async function saveUnitsToBackend(user_id, units) {
  try {
    const { data } = await api.post(
      '/save_unit_settings/',
      { units },
      { params: { user_id } }
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}